import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { commonMenus } from '@/utils/api/common';

const initialState = {
  list: [],
};

export const asyncInitCommonMenus = createAsyncThunk('menus/asyncInitCommonMenus', async (_, state) => {
  const { menus: { list = [] } } = state.getState();
  const { data: { data = {}, code } } = await commonMenus();
  if (+code === 0) {
    return data;
  } else {
    return list;
  }
});

export const slice = createSlice({
  name: 'menus',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncInitCommonMenus.fulfilled, (state, actions) => {
        state.list = actions.payload;
      });
  }
});

export const menuList = (state) => {
  return state.menus.list;
};

export default slice.reducer;